import { ChangeDetectionStrategy, Component } from '@angular/core';

import { BetslipConfig, Sitecore } from '@frontend/sports/common/client-config-data-access';
import { StringInterpolationPipe } from '@frontend/sports/common/core/utils/string-interpolation';
import { EpcotConfigService } from 'packages/sports/web/app/src/common/epcot-config.service';
import { BehaviorSubject } from 'rxjs';

import { BetslipType } from '../../../core/betslip-type';
import { BETSLIP_TYPE_PROVIDER } from '../../../digital/services/betslip-type-provider.service';
import { BaseSingleBetComponent } from './base-single-bet.component';

@Component({
    selector: 'bs-single-bet-linear',
    templateUrl: './single-bet-linear.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    styleUrls: ['./single-bet-linear.component.scss'],
    providers: [{ provide: BETSLIP_TYPE_PROVIDER, useValue: new BehaviorSubject(BetslipType.Single).asObservable() }],
    standalone: false,
})
export class SingleBetLinearComponent extends BaseSingleBetComponent {
    isSelectionsGeneralStakeEnabled: boolean;

    readonly isModuleCollapsible: boolean;

    readonly betslipType = BetslipType.Single;

    readonly isEpcot: boolean;

    constructor(
        betslipConfig: BetslipConfig,
        public override sitecore: Sitecore,
        private interpolatePipe: StringInterpolationPipe,
        epcotConfig: EpcotConfigService,
    ) {
        super(betslipConfig, sitecore);
        this.isSelectionsGeneralStakeEnabled = this.betslipConfig.selectionsGeneralStakeEnabled;
        this.isModuleCollapsible = this.betslipConfig.isLinearCollapsibleModulesEnabled;
        this.isEpcot = epcotConfig.isEnabled();
    }

    protected override get alwaysShowStakeInput() {
        return true;
    }

    selectedPicksTitle(picksCount: number): string {
        return this.interpolatePipe.transform(this.sitecore.betslip.linear.Selections, { count: picksCount });
    }

    showGeneralStakeInHeader(picksCount: number): boolean {
        return this.showGeneralStake(picksCount) && !this.isEpcot;
    }

    showGeneralStakeInBody(picksCount: number): boolean {
        return this.showGeneralStake(picksCount) && this.isEpcot;
    }

    private showGeneralStake(picksCount: number): boolean {
        return picksCount > 1 && this.isSelectionsGeneralStakeEnabled;
    }
}
